import { IUser } from '../../../types';

import { TSetAuthState } from '../types';

import { persistAuthStore } from './authStoreLocalStorageUtils';

/**
 * This updates the profile information on the active session.
 */
export function updateProfileDetailsCallback(set: TSetAuthState) {
  return function updateProfileDetails(updatedProfileDetails: IUser) {
    set(
      ({
        activityLog,
        activeSession,
        allSessionsById,
        allSessionsByIndex,
        allSessionsIndices,
      }) => {
        if (activeSession) {
          const updateSession = {
            ...activeSession,
            user: updatedProfileDetails,
          };

          const persistState = {
            activityLog,
            activeSession: updateSession,
            allSessionsById,
            allSessionsByIndex,
            allSessionsIndices,
          };

          persistAuthStore(persistState);
        }

        return {
          activeSession,
        };
      }
    );
  };
}
